module.exports = __webpack_public_path__ + "static/media/icon12.e418b1f6.svg";